import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@tsin-shared/components/footer/footer.component';
import { MainHeaderComponent } from '@tsin-shared/components/main-header/main-header.component';
import { Store } from '@ngxs/store';
import { LogoutAction } from '@tsin-core/actions/auth.action';
import { environment } from '@tsin-env/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MainHeaderComponent, FooterComponent, FormsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'Touchstone Work With Us Service';
  private store = inject(Store);

  ngOnInit() {
    // Listen for logout events from other tabs
    window.addEventListener('storage', (event) => {
      if (event.key === 'logout-event' && event.newValue) {
        // Logout detected in another tab - force logout here too
        this.store.dispatch(new LogoutAction());
        window.location.href = environment.userMgtUrl;
      }
    });
  }
}
